module.exports = __webpack_public_path__ + "img/icebox-black__close.ece765ec.png";